<template>
    <main class="game-intro">
        <div class="game-card-list">
            <article
                v-for="game in games"
                :key="game.id"
                class="game-card"
            >
                    <div class="game-card-icon-frame">
                        <img
                            class="game-card-icon"
                            :src="game.icon"
                            :alt="`${game.title} icon`"
                            draggable="false"
                        >
                    </div>

                    <div class="game-card-body">
                        <img
                            class="game-card-logo"
                            :src="game.logo"
                            :alt="game.title"
                            draggable="false"
                        >

                        <div class="game-card-content">
                            <p class="game-card-description" v-html="game.description"></p>
                            <nav class="game-social-links" aria-label="社群連結">
                                <a
                                    v-for="social in socialLinks"
                                    :key="social.type"
                                    :href="social.href || undefined"
                                    :aria-label="social.label"
                                    :aria-disabled="!social.href"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    @click="preventEmptyLink($event, social.href)"
                                >
                                    <svg v-if="social.type === 'instagram'" viewBox="0 0 24 24" aria-hidden="true">
                                        <rect x="4" y="4" width="16" height="16" rx="5"></rect>
                                        <circle cx="12" cy="12" r="4"></circle>
                                        <circle class="social-icon-fill" cx="17.4" cy="6.8" r="1"></circle>
                                    </svg>
                                    <svg v-else viewBox="0 0 24 24" aria-hidden="true">
                                        <path class="social-icon-fill" d="M13.7 21v-8h2.8l.4-3.1h-3.2V8c0-.9.3-1.5 1.6-1.5H17V3.7c-.7-.1-1.5-.2-2.4-.2-2.4 0-4.1 1.5-4.1 4.2v2.2H8V13h2.5v8h3.2Z"></path>
                                    </svg>
                                </a>
                            </nav>
                            <div class="game-card-actions">
                                <button
                                    type="button"
                                    class="game-link-button"
                                    @click="downloadGame(game)"
                                >
                                    <span>下載遊戲</span>
                                </button>
                            </div>
                        </div>
                    </div>
            </article>
        </div>

        <div
            v-if="selectedGame"
            class="game-store-dialog-backdrop"
            role="presentation"
            @click.self="closeStoreDialog"
        >
            <section
                class="game-store-dialog"
                role="dialog"
                aria-modal="true"
                :aria-label="`${selectedGame.title}下載平台`"
            >
                <button
                    class="game-store-dialog-close"
                    type="button"
                    aria-label="關閉"
                    @click="closeStoreDialog"
                >
                    &times;
                </button>
                <h2>選擇下載平台</h2>
                <div class="game-store-options">
                    <a
                        :class="{'is-disabled': !selectedGame.appStoreUrl}"
                        :href="selectedGame.appStoreUrl || undefined"
                        :aria-disabled="!selectedGame.appStoreUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                        @click="preventEmptyLink($event, selectedGame.appStoreUrl)"
                    >
                        App Store
                    </a>
                    <a
                        :class="{'is-disabled': !selectedGame.googlePlayUrl}"
                        :href="selectedGame.googlePlayUrl || undefined"
                        :aria-disabled="!selectedGame.googlePlayUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                        @click="preventEmptyLink($event, selectedGame.googlePlayUrl)"
                    >
                        Google Play
                    </a>
                </div>
            </section>
        </div>
    </main>
</template>

<script>
export default {
    name: 'GameIntro',
    data() {
        return {
            selectedGame: null,
            socialLinks: [{
                type: 'instagram',
                label: 'Instagram',
                href: 'https://www.instagram.com/pockettortoise/'
            }, {
                type: 'facebook',
                label: 'Facebook',
                href: 'https://facebook.com/105286721485161'
            }],
            games: [{
                id: 'pocket-tortoise',
                title: '口袋陸龜',
                icon: new URL('../assets/images/game-intro/ptl/PT-app-icon_o.png', import.meta.url).href,
                logo: new URL('../assets/images/game-intro/ptl/splash-logo.png', import.meta.url).href,
                description: '陸龜收集養成手遊!<br/>一起來養可愛的陸龜吧！',
                appStoreUrl: 'https://apps.apple.com/app/id6747054097',
                googlePlayUrl: 'https://play.google.com/store/apps/details?id=tw.com.cloudybay.ptl'
            }, {
                id: 'racing-tortoise',
                title: '口袋賽龜',
                icon: new URL('../assets/images/game-intro/rt/RT-app-icon_o.png', import.meta.url).href,
                logo: new URL('../assets/images/game-intro/rt/splash-logo.webp', import.meta.url).href,
                description: '帶上你親手照顧的愛龜<br/>挑戰龜速!',
                appStoreUrl: 'https://apps.apple.com/app/id6803418421',
                googlePlayUrl: 'https://play.google.com/store/apps/details?id=tw.com.cloudybay.runningtortoise'
            }]
        }
    },
    mounted() {
        window.addEventListener('keydown', this.handleKeydown)
    },
    beforeUnmount() {
        window.removeEventListener('keydown', this.handleKeydown)
    },
    methods: {
        downloadGame(game) {
            const userAgent = navigator.userAgent || ''
            const isAndroid = /Android/i.test(userAgent)
            const isIOS = /iPhone|iPad|iPod/i.test(userAgent)
                || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

            if (isAndroid && game.googlePlayUrl) {
                this.openExternalLink(game.googlePlayUrl)
                return
            }

            if (isIOS && game.appStoreUrl) {
                this.openExternalLink(game.appStoreUrl)
                return
            }

            this.selectedGame = game
        },
        openExternalLink(url) {
            window.open(url, '_blank', 'noopener,noreferrer')
        },
        closeStoreDialog() {
            this.selectedGame = null
        },
        handleKeydown(event) {
            if (event.key === 'Escape') this.closeStoreDialog()
        },
        preventEmptyLink(event, href) {
            if (!href) event.preventDefault()
        }
    }
}
</script>
